exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedorBotones[data-v-548639e3]{display:inline-flex;margin-bottom:1.25vw;padding-left:2.8%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-548639e3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/OverlaySubirArchivo/OverlaySubirArchivo.scss
// module id = 1060
// module chunks = 0